var path = '/components/directives/select-box/select-box-directive.tpl.html';
var html = "<style>\n    .loading .selectize-input {\n        background: #dfdfdf;\n    }\n</style>\n<div class=\"al-select\">\n    <select></select>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/select-box/select-box-directive.tpl.html
// module id = 2006
// module chunks = 1